@if (stack) {
<qa-print-flash-card-stack [flashCards]="stack"> </qa-print-flash-card-stack>
}
